export interface LogoProps {
  /** Rendered width in px; height follows the wordmark's aspect ratio. */
  width?: number;
  /** Rendered height in px; overrides `width` when given. */
  height?: number;
  className?: string;
}

/**
 * The Noti wordmark, inlined so it can take `currentColor` and follow the
 * theme token. Loaded as an `<img>` it could not adapt to dark mode.
 *
 * Source: design/logo.svg (noti-brandkit.pdf, Brand system 01.0). The viewBox
 * is 1349x376, so the mark is ~3.59:1.
 */
export function Logo({ width, height, className }: LogoProps): React.ReactNode {
  const w = height ? Math.round((height * 1349) / 376) : (width ?? 160);
  const h = height ?? Math.round((w * 376) / 1349);
  return (
    <svg
      viewBox="109 105 1349 376"
      width={w}
      height={h}
      fill="currentColor"
      role="img"
      aria-label="Noti"
      focusable="false"
      className={className}
    >
      <path d="M110,110 H221 V313 L369,165 V110 H479 V479 H369 V313 L221,461 V479 H110 Z" />
      <path
        fillRule="evenodd"
        d="M1070.7,455.5 C1022.0,447.3 986.9,411.0 977.3,358.6 C974.6,344.4 974.9,314.9 977.8,300.2 C990.4,236.6 1039.4,199.3 1103.8,204.0 C1151.7,207.6 1188.9,236.9 1204.0,283.1 C1210.4,302.7 1212.7,331.1 1209.6,353.3 C1201.9,408.2 1166.5,446.7 1115.6,455.5 C1104.8,457.3 1081.7,457.3 1070.7,455.5 Z M727.0,330.5 L727.0,209.0 L753.0,209.0 L779.0,209.0 L779.2,227.2 L779.5,245.4 L782.4,240.9 C793.5,224.0 810.0,212.1 829.5,206.8 C841.0,203.7 865.9,203.8 877.5,206.9 C906.2,214.6 926.4,234.0 935.3,262.5 C940.4,278.6 940.5,281.5 940.5,369.5 L940.5,451.5 L913.8,451.8 L887.1,452.0 L886.7,371.8 C886.4,284.1 886.6,287.9 880.5,275.4 C871.6,257.3 848.7,247.9 824.0,252.4 C800.8,256.6 785.7,272.3 781.5,296.4 C780.3,303.8 780.0,317.3 780.0,378.6 L780.0,452.0 L753.5,452.0 L727.0,452.0 L727.0,330.5 Z M1319.2,450.9 C1292.3,447.8 1276.3,436.7 1268.8,415.9 L1266.5,409.5 L1266.0,331.0 L1265.5,252.5 L1244.2,252.2 L1223.0,252.0 L1223.0,230.5 L1223.0,209.0 L1244.2,208.8 L1265.5,208.5 L1265.5,175.7 L1265.5,143.0 L1292.2,143.0 L1319.0,143.0 L1319.0,176.0 L1319.0,209.0 L1343.5,209.0 L1368.0,209.0 L1368.0,230.5 L1368.0,252.0 L1343.5,252.0 L1319.0,252.0 L1319.0,321.8 C1319.0,397.1 1319.0,397.2 1324.4,402.6 C1328.9,407.1 1333.3,408.0 1351.8,408.0 L1368.0,408.0 L1368.0,430.0 L1368.0,452.0 L1347.2,451.9 C1335.8,451.8 1323.2,451.4 1319.2,450.9 Z M1399.0,330.5 L1399.0,209.0 L1425.5,209.0 L1452.0,209.0 L1452.0,330.5 L1452.0,452.0 L1425.5,452.0 L1399.0,452.0 L1399.0,330.5 Z M1107.9,410.5 C1133.2,404.5 1150.4,383.2 1155.5,351.5 C1159.6,326.6 1155.8,298.6 1145.8,279.8 C1125.0,240.5 1066.7,238.1 1043.0,275.6 C1033.2,291.2 1029.6,305.8 1029.5,330.5 C1029.5,355.4 1033.4,370.7 1043.6,386.1 C1057.3,406.7 1082.8,416.4 1107.9,410.5 Z M1416.7,169.0 C1388.4,161.8 1384.5,123.1 1410.8,110.3 C1419.2,106.3 1432.0,106.3 1440.2,110.3 C1464.2,122.1 1463.7,156.4 1439.3,167.2 C1434.2,169.5 1422.4,170.4 1416.7,169.0 Z"
      />
    </svg>
  );
}
